import { render, staticRenderFns } from "./PrivacyGlobalModal.vue?vue&type=template&id=22461abb&scoped=true"
import script from "./PrivacyGlobalModal.vue?vue&type=script&lang=js"
export * from "./PrivacyGlobalModal.vue?vue&type=script&lang=js"
import style0 from "./PrivacyGlobalModal.vue?vue&type=style&index=0&id=22461abb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22461abb",
  null
  
)

export default component.exports